import { render, staticRenderFns } from "./tongjiCard.vue?vue&type=template&id=86baf29a&scoped=true&"
import script from "./tongjiCard.vue?vue&type=script&lang=js&"
export * from "./tongjiCard.vue?vue&type=script&lang=js&"
import style0 from "./tongjiCard.vue?vue&type=style&index=0&id=86baf29a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86baf29a",
  null
  
)

export default component.exports